import script from "./FilterOnThTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterOnThTable.vue?vue&type=script&setup=true&lang=js"

import "./FilterOnThTable.vue?vue&type=style&index=0&id=40511425&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40511425"]])

export default __exports__